module.exports = __webpack_public_path__ + "static/media/door.0328e348.svg";